"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconEarth1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconEarth1, _Icon);
  function IconEarth1(props) {
    var _this;
    _classCallCheck(this, IconEarth1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconEarth1).call(this, props));
    _this.name = 'IconEarth1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "earth-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "earth-1_svg__path0",
      d: "M12 23.985c-1.429 0-2.831-.251-4.165-.747-.011-.004-.027-.009-.043-.017C3.131 21.471 0 16.956 0 11.985c0-.668.059-1.351.175-2.03.002-.021.007-.043.01-.057A11.975 11.975 0 0112-.015c3.249 0 6.293 1.284 8.573 3.615a.5.5 0 01.084.088 11.937 11.937 0 013.074 10.816.477.477 0 01-.039.171c-1.241 5.396-6.154 9.31-11.692 9.31zm-3.5-1.573a10.99 10.99 0 0014.083-7.427h-.472a3.495 3.495 0 01-2.916-1.559l-2.218-3.329a2.482 2.482 0 00-2.067-1.112h-.449a2.753 2.753 0 01-2.749-2.749c0-.735.286-1.425.805-1.945a2.727 2.727 0 011.944-.806h4.511A10.949 10.949 0 0012 .985c-5.104 0-9.56 3.556-10.713 8.5h5.47c.936 0 1.814.364 2.476 1.024l1.121 1.121a3.504 3.504 0 01.141 4.801l-1.363 1.533a2.494 2.494 0 00-.632 1.661v2.787zM1.103 10.485A10.969 10.969 0 007.5 22.02v-2.395c0-.858.314-1.684.885-2.325l1.363-1.533a2.502 2.502 0 00-.101-3.429l-1.121-1.121a2.483 2.483 0 00-1.767-.732H1.103zm13.358-6c-.468 0-.907.182-1.237.513a1.753 1.753 0 001.237 2.988h.432c1.177 0 2.265.582 2.916 1.557l2.218 3.329a2.496 2.496 0 002.08 1.114h.71c.121-.657.182-1.329.182-2 0-2.794-1.052-5.453-2.965-7.5h-5.573z"
    })));
    return _this;
  }
  return IconEarth1;
}(_Icon3.default);
exports.default = IconEarth1;